import React from 'react'
import 'animate.css'
import { useRef, useEffect } from 'react';
import WorkEx from './WorkEx';
import Projects from './Projects';

function Home() {
    
  return (
    
     <div
      name="home"
      className="w-full"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row mt-12">
        <div className="flex flex-col justify-center h-full">
          <h3 className='text-6xl  mb-8 '>I am,</h3>
          <h2 className='text-8xl mb-8 animate-bounce'>Rhythm Batra</h2>
          <h3 className='text-6xl mb-8'>- Software Developer</h3>

          <div>
            
          {/* I have 2.5 years of experience building and desgining software.
          Currently, I love to work on web application development using technologies like
          React, Tailwin.css, Daisy Ui, Django(Python), Django Rest Framework and Kubernetes. */}

          I'm a Full Stack Developer with a 2.5 years of proven track record of success in top-tier product-based companies. 
          With a strong foundation in Python, Django, Django Rest Framework, React.js, Automation, and Kubernetes, 
          I bring innovative solutions to the table.
          <br></br>
          <br></br>
          🛠️ Skills & Strengths 🛠️
          <br></br>
          ✅ Python & Django: Proficient in building robust and scalable web applications.<br></br>
          ✅ React.js: Expertise in creating dynamic and responsive user interfaces.<br></br>
          ✅ Kubernetes: Skilled in container orchestration for seamless deployment.<br></br>
          ✅ Automation: Experienced in streamlining workflows and optimizing processes.<br></br>
          ✅ Problem Solver: A knack for finding efficient solutions to complex challenges.<br></br>
          ✅ Top Product Experience: Worked on cutting-edge projects in high-impact environments.<br></br>
            
          </div>
           
            </div>
        </div>


















   {/* <section class="relative">
    
    <div class="relative z-10 container px-4 mx-auto">
  <div class="flex flex-wrap lg:items-center -m-8">
    <div class="w-full md:w-1/2 p-8">
    <div className='ml-30 mb-20'>
          <h3 className='text-6xl  mb-8 '>I am,</h3>
        <h2 className='text-8xl mb-8 animate-bounce'>Rhythm Batra</h2>
        <h3 className='text-6xl mb-8'>- Software Developer</h3>
        </div>
      
    </div>
    <div class="w-full md:w-1/2 p-8">
      <div class="md:max-w-md mx-auto  shadow-8xl">
        <div class="p-600">
          <div className="card  bg-base-100 shadow-xl    mb-8">

        <div className="card-body">
        
           <h2 className="card-title center">Skills</h2>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Python</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">Django</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-info">React.js</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-success">Git</button>
                
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Data Structures & Algorithms</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">Android(Java)</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-info">Object Oriented Programming Concepts</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-success">Firebase</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Database Management Systems</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">MS SQL</button>
           </div>
            </div>
            </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
</section> 
     */}
    {/* <div class="flex justify-between ... sm:text-xl">
    <div className='mt-50 ml-30 mb-20'>
        <h3 className='text-6xl mt-50 ml-30 mb-8 '>I am,</h3>
        <h2 className='text-8xl mt-70 ml-30 mb-8 animate-bounce '>Rhythm Batra</h2>
        <h3 className='text-6xl mt-50 ml-30 mb-8'>- Software Developer</h3>
    </div>
    <div className='mt-50 ml-100 mb-8 mr-40'>
        <div className="card card-compact w-96 bg-base-100 shadow-xl mt-50 ml-100 mb-8">

        <div className="card-body">
        
           <h2 className="card-title center">Skills</h2>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Python</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">Django</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-info">React.js</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-success">Git</button>
                
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Data Structures & Algorithms</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">Android(Java)</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-info">Object Oriented Programming Concepts</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-success">Firebase</button>
           </div>
           <div class="btn-group">
                <button class="btn btn-md btn-wide btn-outline btn-success">Database Management Systems</button>
                <button class="btn btn-disabled"></button>
                <button class="btn btn-md btn-wide btn-outline btn-info">MS SQL</button>
           </div>
            </div>
            </div>
        </div>
    </div>
    
    <br></br>
    <br></br>
    <br></br>
    
    <u><h2 className='text-6xl ml-150 mb-8'>My Projects</h2></u> */}




</div>
    

  )
}

export default Home